import React, { useState, useEffect } from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
import { CLIENT_ID } from '../../config';
import axios from 'axios';
import qs from 'qs';
import reactUuid from 'react-uuid';

export default function PayPal(props) {
  const pypalCode = props.currencyCode;
  const paypalAmount = props.amount;
  const { info, modalClose, setAlert } = props;
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [orderID, setOrderID] = useState('');

  console.log(info['deepgramInfo']['applicationID'][0]['id']);
  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: info['deepgramInfo']['applicationID'][0]['id'],
            amount: {
              currency_code: pypalCode,
              value: paypalAmount,
            },
          },
        ],
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    return actions.order.capture().then((details) => {
      const { payer } = details;
      console.log(payer);
      setSuccess(true);
    });
  };

  const onError = (data, actions) => {
    setErrorMessage('An Error occured with your payment');
  };

  useEffect(() => {
    if (success) {
      console.log('Order successful. Your orderID is--', orderID);
      axios
        .post(
          'https://www.teleconnx.com/order-details/',
          qs.stringify({
            ...info,
            orderID: orderID,
            status: 'success',
          }),
          {
            mode: 'cors',
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods': 'GET,HEAD,PUT,PATCH,POST,DELETE',
              //   Vary: 'Origin,Accept-Encoding,User-Agent',
              //   'Access-Control-Allow-Headers':
              //     'Origin, X-Requested-With, Content-Type, Accept, Authorization, Vary, Content-Encoding, Cache-Control, Strict-Transport-Security',
              //   // 'Access-Control-Allow-Credentials': 'true',
              //   'Content-Encoding': 'gzip',
              //   // Vary: 'Accept-Encoding,User-Agent',
              //   'Cache-Control': 'max-age=0',
              //   'Content-Type': 'text/html; charset=UTF-8',
              //   // 'Access-Control-Allow-Headers':
              //   //   'Origin, X-Requested-With, Content-Type, Accept, Authorization',
              //   // 'Access-Control-Request-Method': 'GET, POST, DELETE, PUT, OPTIONS',
            },
            // withCredentials: true,
          }
        )
        .then((response) => {
          setAlert(1);
          modalClose();
          console.log(`success: ${response.status}`);
        })
        .catch((err) => {
          console.log('error' + err);
        });
      if (errorMessage) {
        axios
          .post(
            'https://www.teleconnx.com/order-details/',
            qs.stringify({
              ...info,
              status: 'failure',
            }),
            {
              mode: 'cors',
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods':
                  'GET,HEAD,PUT,PATCH,POST,DELETE',
              },
            }
          )
          .then((response) => {
            console.log(`error - success: ${response.status}`);
            setAlert(2);
            modalClose();
          })
          .catch((err) => {
            console.log('error' + err);
          });
      }
      // axios
      //   .post(
      //     'https://www.teleconnx.com/order-details',

      //     {
      //       headers: {
      //         Server: 'Apache',
      //         'Strict-Transport-Security':
      //           'max-age=31536000; includeSubDomains',
      //         'Access-Control-Allow-Origin': '*',
      //         'Content-Type': 'text/html; charset=iso-8859-1',
      //         // 'Access-Control-Allow-Origin': '*',
      //         // // 'Access-Control-Allow-Credentials': 'true',
      //         'Access-Control-Allow-Headers':
      //           'Origin, X-Requested-With, Content-Type, Accept',
      //         'Access-Control-Allow-Methods':
      //           'PUT, POST, GET, DELETE, PATCH, OPTIONS',
      //         // // Accept: 'application/json, text/plain, */*',
      //         // // 'Accept-Encoding': 'gzip, deflate, br',
      //         // 'Content-Encoding': 'gzip',
      //         // Vary: 'Accept-Encoding,User-Agent',
      //         // 'Content-Type': 'application/json',
      //       },
      //     }
      //   )
      //   .then((result) => {
      //     console.log('succeed');
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    }
  }, [success, errorMessage]);

  return (
    <PayPalScriptProvider
      options={{
        'client-id': CLIENT_ID,
        components: 'buttons',
        currency: pypalCode,
      }}
    >
      <PayPalButtons
        style={{ color: 'white', label: 'pay' }}
        fundingSource='paypal'
        createOrder={createOrder}
        onApprove={onApprove}
        onError={onError}
      />
    </PayPalScriptProvider>
  );
}
